import { intersection } from 'lodash/array';
import {
    MOVE_OBJECT,
    PURCHASE_STATUS_CHANGE,
    SELECTION_TOGGLE,
    PROPS_CHANGED,
} from '%paysera_seat_selection/js/seatSelection/config/changeSet';
import compileSeatTranslation from './compileSeatTranslation';
import compileSeatDimensions from './compileSeatDimensions';
import compileSeatPolygon from './compileSeatPolygon';
import compileSeatLabel from './compileSeatLabel';
import compileSeatCacheKey from './compileSeatCacheKey';

function compileSeat(seat, changeSet) {
    let compiledSeat = seat;

    if (intersection(changeSet.seat, [PROPS_CHANGED]).length > 0) {
        compiledSeat = compileSeatCacheKey(compiledSeat, Math.random());

        return compiledSeat;
    }
    if (intersection(changeSet.seat, [SELECTION_TOGGLE]).length > 0) {
        compiledSeat = compileSeatCacheKey(compiledSeat);

        return compiledSeat;
    }
    if (intersection(changeSet.seat, [PURCHASE_STATUS_CHANGE]).length > 0) {
        compiledSeat = compileSeatDimensions(compiledSeat);
        compiledSeat = compileSeatCacheKey(compiledSeat, Math.random());

        return compiledSeat;
    }
    if (intersection(changeSet.seat, [MOVE_OBJECT]).length > 0) {
        compiledSeat = compileSeatTranslation(compiledSeat);
        compiledSeat = compileSeatDimensions(compiledSeat);
        compiledSeat = compileSeatPolygon(compiledSeat);
        compiledSeat = compileSeatCacheKey(compiledSeat);

        return compiledSeat;
    }

    compiledSeat = compileSeatTranslation(compiledSeat);
    compiledSeat = compileSeatDimensions(compiledSeat);
    compiledSeat = compileSeatPolygon(compiledSeat);
    compiledSeat = compileSeatLabel(compiledSeat);
    compiledSeat = compileSeatCacheKey(compiledSeat);

    return compiledSeat;
}

export default compileSeat;
